interface ArticleLinkProps {
  title: string;
  href: string;
  tags?: string[];
}

export default function ArticleLink({ title, href, tags }: ArticleLinkProps) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className="card rounded-lg p-4 block hover:no-underline">
      <span className="text-sm font-medium link">{title}</span>
      {tags && tags.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mt-2">
          {tags.map((t) => (
            <span key={t} className="tag">{t}</span>
          ))}
        </div>
      )}
    </a>
  );
}
